import { getVehicleOrderFormData, findCartVehicle } from 'cart'
import UserActionsServiceProvider from '../../services/UserActionsServiceProvider'
import {
  IParts,
  IUserActions,
  VehicleWithParts,
} from '../../store/models/IUserActions'
import { StoreInstances } from '../../store/StoreInstancesContainer'
import { UserAttributeKey } from '../../store/user/interfaces'
import { store } from 'store'
import { storeInfo } from 'src/helpers/StoreInfo'
import { Address } from 'src/api/user/interfaces'
import { getServiceName } from 'src/helpers/getServiceName'
import { IS_INTEGRATED_VERSION } from '../ConfigManager'
import { embeddedConfigManager } from 'src/api/embedded/EmbeddedConfigManager'

export const CART_SESSION_KEY = 'cartSession'

export enum CartActionType {
  cartDelete = 'CartDelete',
  cartItemDelete = 'CartItemDelete',
}

export enum QuoteActionType {
  quoteDelete = 'QuoteDelete',
  quoteReCheck = 'QuoteReCheck',
}

export const makeUserActivityReqBody = (
  actionType: CartActionType | QuoteActionType,
  parts: IParts[],
  quoteId?: string
): IUserActions => {
  const cartSession = crypto.randomUUID() || ''

  const address = (store
    .getState()
    .cart.addresses?.find((a) => a.addressType === 'Primary') ||
    storeInfo.getContactAdressInfo()?.address) as Address | undefined

  return {
    user: {
      userId: Number(StoreInstances.userStore.preferences.userId),
      orgId: Number(StoreInstances.userStore.preferences.orgId),
      partDomain: StoreInstances.userStore.getUserAttribute(
        UserAttributeKey.partDomain
      ),
      screenName: StoreInstances.userStore.preferences.screenName,
      wdorgId: StoreInstances.userStore.preferences.wdorgId,
      wdOrgName: StoreInstances.userStore.preferences.wdOrgName,
      orgName: StoreInstances.userStore.preferences.orgName,
      serviceName: getServiceName(),
      partnerName: IS_INTEGRATED_VERSION
        ? embeddedConfigManager.getPartsBasketCreds().partnerId
        : '',
      sellerCode: IS_INTEGRATED_VERSION
        ? embeddedConfigManager.getPartsBasketCreds().sellerId
        : '',
      buyerCode: IS_INTEGRATED_VERSION
        ? embeddedConfigManager.getPartsBasketCreds().buyerId
        : '',
    },
    cartSession,
    action: actionType,
    quoteId,
    parts,
    address,
  }
}

const getSearchTypes = (value: number) => {
  switch (value) {
    case 0:
      return 'None'
    case 1:
      return 'YMME'
    case 2:
      return 'GFX'
    case 3:
      return 'Search Results'
    case 4:
      return 'Interchange'
    case 5:
      return 'SAYT'
    default:
      return 'None'
  }
}

export const buildPartsWithVehicleInfo = (
  vehicleWithParts: VehicleWithParts
): IParts[] => {
  return vehicleWithParts.parts.map((p) => {
    const { quoteSourceId } = findCartVehicle(
      store.getState().cart,
      vehicleWithParts
    )
    const formData = getVehicleOrderFormData(store.getState(), vehicleWithParts)
    const { parts, ...vehicleInfo } = vehicleWithParts
    return {
      ...p,
      vehicle: vehicleInfo,
      quoteId: (quoteSourceId || '').trim() ? Number(quoteSourceId) : 0,
      lookup: '',
      lookupType: getSearchTypes(
        StoreInstances.searchStore.lastNonCachedSearch
      ),
      multiseller: false,
      coverageKey: '',
      poNumber: formData?.poNumber || '',
    }
  })
}

export const trackUserAction = async (
  actionType: CartActionType | QuoteActionType,
  parts: IParts[],
  quoteId?: string
): Promise<void> => {
  const reqBody = makeUserActivityReqBody(actionType, parts, quoteId)
  await UserActionsServiceProvider.sendUserActions(reqBody)
}
